import {
  Target,
  FileText,
  GraduationCap,
  Plane,
  Globe,
  Home,
  DollarSign,
  Briefcase,
  Phone,
  Search,
  Building2,
  ClipboardList,
  Upload,
  CreditCard,
  Activity,
  Scale,
  FileCheck,
  Calendar,
  Video,
  MessageCircle,
  Wallet,
  Eye,
  MapPin,
  Shield,
  CheckCircle,
  Banknote,
  Users,
  Package,
  Calculator,
  TrendingDown,
  Lock,
  BarChart3,
  Linkedin,
  FileEdit,
  Mail,
  CheckSquare,
  Award,
} from 'lucide-react';

// ─── Service Icon Images ───────────────────────────────────────
import profileAssessmentIcon from '../assets/Icon/Profile Assessment.png';
import preapplicationSupportIcon from '../assets/Icon/Preapplication Support.png';
import applyUniversityIcon from '../assets/Icon/Apply University.png';
import visaInterviewIcon from '../assets/Icon/Visa & Interview Support.png';
import ticketTravelIcon from '../assets/Icon/Ticket & Travel Support.png';
import accommodationIcon from '../assets/Icon/Find Accommodation.png';
import educationLoanIcon from '../assets/Icon/Education Loan.png';
import jobsAbroadIcon from '../assets/Icon/Find Jobs Abroad.png';

// ─── Service Cover Images ─────────────────────────────────────
import profileAssessmentImg from '../assets/services-img/services-1.png';
import preapplicationSupportImg from '../assets/services-img/services-2.png';
import applyUniversityImg from '../assets/services-img/services-3.png';
import visaInterviewImg from '../assets/services-img/services-4.png';
import ticketTravelImg from '../assets/services-img/services-5.png';
import accommodationImg from '../assets/services-img/services-6.png';
import educationLoanImg from '../assets/services-img/services-7.jpg';
import jobsAbroadImg from '../assets/services-img/services-8.png';

// ─── Color Themes ──────────────────────────────────────────────
export const SERVICE_THEMES = {
  'profile-assessment': {
    gradient: 'from-blue-500 to-indigo-700',
    accent: '#6366F1',
    lightBg: '#EEF2FF',
    iconColor: 'text-indigo-500',
    badgeBg: 'bg-indigo-50',
    badgeText: 'text-indigo-700',
    borderColor: 'border-indigo-100',
    stepColor: 'bg-indigo-500',
    stepBg: 'bg-indigo-50',
    heroGradient: 'from-indigo-500 to-blue-600',
    heroShadow: 'shadow-indigo-500/20',
    cardBg: 'bg-indigo-50/40',
  },
  'preapplication-support': {
    gradient: 'from-emerald-50 to-teal-50',
    accent: '#14B8A6',
    lightBg: '#F0FDFA',
    iconColor: 'text-teal-500',
    badgeBg: 'bg-teal-50',
    badgeText: 'text-teal-700',
    borderColor: 'border-teal-100',
    stepColor: 'bg-teal-500',
    stepBg: 'bg-teal-50',
    heroGradient: 'from-teal-500 to-emerald-600',
    heroShadow: 'shadow-teal-500/20',
    cardBg: 'bg-teal-50/40',
  },
  'apply-university': {
    gradient: 'from-violet-50 to-purple-50',
    accent: '#8B5CF6',
    lightBg: '#F5F3FF',
    iconColor: 'text-purple-500',
    badgeBg: 'bg-purple-50',
    badgeText: 'text-purple-700',
    borderColor: 'border-purple-100',
    stepColor: 'bg-purple-500',
    stepBg: 'bg-purple-50',
    heroGradient: 'from-purple-500 to-violet-600',
    heroShadow: 'shadow-purple-500/20',
    cardBg: 'bg-purple-50/40',
  },
  'visa-interview': {
    gradient: 'from-rose-50 to-pink-50',
    accent: '#F43F5E',
    lightBg: '#FFF1F2',
    iconColor: 'text-rose-500',
    badgeBg: 'bg-rose-50',
    badgeText: 'text-rose-700',
    borderColor: 'border-rose-100',
    stepColor: 'bg-rose-500',
    stepBg: 'bg-rose-50',
    heroGradient: 'from-rose-500 to-pink-600',
    heroShadow: 'shadow-rose-500/20',
    cardBg: 'bg-rose-50/40',
  },
  'ticket-travel': {
    gradient: 'from-amber-50 to-yellow-50',
    accent: '#F59E0B',
    lightBg: '#FFFBEB',
    iconColor: 'text-amber-500',
    badgeBg: 'bg-amber-50',
    badgeText: 'text-amber-700',
    borderColor: 'border-amber-100',
    stepColor: 'bg-amber-500',
    stepBg: 'bg-amber-50',
    heroGradient: 'from-amber-500 to-yellow-600',
    heroShadow: 'shadow-amber-500/20',
    cardBg: 'bg-amber-50/40',
  },
  accommodation: {
    gradient: 'from-cyan-50 to-sky-50',
    accent: '#06B6D4',
    lightBg: '#ECFEFF',
    iconColor: 'text-cyan-500',
    badgeBg: 'bg-cyan-50',
    badgeText: 'text-cyan-700',
    borderColor: 'border-cyan-100',
    stepColor: 'bg-cyan-500',
    stepBg: 'bg-cyan-50',
    heroGradient: 'from-cyan-500 to-sky-600',
    heroShadow: 'shadow-cyan-500/20',
    cardBg: 'bg-cyan-50/40',
  },
  'education-loan': {
    gradient: 'from-lime-50 to-green-50',
    accent: '#84CC16',
    lightBg: '#F7FEE7',
    iconColor: 'text-lime-600',
    badgeBg: 'bg-lime-50',
    badgeText: 'text-lime-700',
    borderColor: 'border-lime-100',
    stepColor: 'bg-lime-600',
    stepBg: 'bg-lime-50',
    heroGradient: 'from-lime-500 to-green-600',
    heroShadow: 'shadow-lime-500/20',
    cardBg: 'bg-lime-50/40',
  },
  'jobs-abroad': {
    gradient: 'from-orange-50 to-red-50',
    accent: '#F97316',
    lightBg: '#FFF7ED',
    iconColor: 'text-orange-500',
    badgeBg: 'bg-orange-50',
    badgeText: 'text-orange-700',
    borderColor: 'border-orange-100',
    stepColor: 'bg-orange-500',
    stepBg: 'bg-orange-50',
    heroGradient: 'from-orange-500 to-red-600',
    heroShadow: 'shadow-orange-500/20',
    cardBg: 'bg-orange-50/40',
  },
};

// ─── Full Service Data ──────────────────────────────────────────
export const SERVICE_DATA = {
  'profile-assessment': {
    slug: 'profile-assessment',
    type: 'PROFILE_ASSESSMENT',
    name: 'Profile Assessment',
    tagline:
      'Get a comprehensive evaluation of your academic profile and discover your best-fit universities worldwide.',
    description:
      'Comprehensive evaluation of your academic and professional profile to identify the best opportunities.',
    duration: '2-3 days',
    price: '$99',
    icon: Target,
    heroIcon: profileAssessmentIcon,
    heroImage: profileAssessmentImg,
    popular: true,
    processSteps: [
      { label: 'You Apply', subtitle: 'Instant', icon: ClipboardList },
      { label: 'Admin Reviews', subtitle: '1-2 days', icon: Eye },
      { label: 'Counselor Assigned', subtitle: '1 day', icon: Users },
      {
        label: 'Profile Analyzed & Report Generated',
        subtitle: '2-3 days',
        icon: FileCheck,
      },
      { label: 'Completed', subtitle: 'Report delivered', icon: CheckCircle },
    ],
    deliverables: [
      { name: '1-on-1 consultation call (30 min)', icon: Phone },
      { name: 'Academic profile analysis report (PDF)', icon: FileText },
      { name: 'Gap analysis & improvement areas', icon: Search },
      { name: 'Top 10 university recommendations', icon: Building2 },
      { name: 'Country-wise eligibility breakdown', icon: Globe },
      { name: 'Personalized application strategy', icon: Target },
    ],
    faqs: [
      {
        q: 'How long does Profile Assessment take?',
        a: 'Typically 2-3 business days after your documents are reviewed.',
      },
      {
        q: 'What documents do I need?',
        a: 'Academic transcripts, English test scores (IELTS/TOEFL if available), passport copy, and CV/resume.',
      },
      {
        q: 'Can I cancel after applying?',
        a: 'Yes, you can request cancellation within 24 hours for a full refund.',
      },
      {
        q: "What if I'm not satisfied with the recommendations?",
        a: 'We offer one revision round. If still unsatisfied, contact support for options.',
      },
      {
        q: 'Do I need IELTS/TOEFL scores?',
        a: 'Not mandatory for assessment, but having them helps us give more accurate recommendations.',
      },
    ],
    prerequisites: [
      'Passport copy (or national ID)',
      'Academic transcripts (latest)',
      'English test score (if available)',
      'Updated CV/Resume',
    ],
    testimonials: [
      {
        name: 'Sneha K.',
        country: 'India',
        university: 'University of Toronto',
        quote:
          'The profile assessment gave me clarity on where I stand. Got into my dream university!',
        rating: 5,
      },
      {
        name: 'Ahmed R.',
        country: 'Bangladesh',
        university: 'University of Melbourne',
        quote:
          'Very detailed report with actionable suggestions. Highly recommend!',
        rating: 5,
      },
    ],
    stats: {
      studentsServed: '1,200+',
      satisfaction: '98%',
      avgCompletion: '3 days',
    },
    relatedServices: ['preapplication-support', 'apply-university'],
  },

  'preapplication-support': {
    slug: 'preapplication-support',
    type: 'UNIVERSITY_SHORTLISTING',
    name: 'Pre-application Support',
    tagline:
      'Get your documents application-ready with expert SOP, LOR, and CV guidance.',
    description:
      'Expert guidance to identify and shortlist universities that match your profile and goals.',
    duration: '1-2 weeks',
    price: '$149',
    icon: FileEdit,
    heroIcon: preapplicationSupportIcon,
    heroImage: preapplicationSupportImg,
    popular: true,
    processSteps: [
      { label: 'You Apply', subtitle: 'Instant', icon: ClipboardList },
      { label: 'Admin Reviews', subtitle: '1-2 days', icon: Eye },
      { label: 'Counselor Assigned', subtitle: '1 day', icon: Users },
      {
        label: 'Documents Reviewed & Prepared',
        subtitle: '1-2 weeks',
        icon: FileCheck,
      },
      { label: 'Completed', subtitle: 'Docs ready', icon: CheckCircle },
    ],
    deliverables: [
      { name: 'SOP (Statement of Purpose) review', icon: FileEdit },
      { name: 'LOR (Letter of Recommendation) guidance', icon: Mail },
      { name: 'Resume/CV formatting for universities', icon: FileText },
      { name: 'Document checklist & verification', icon: CheckSquare },
      { name: 'Application timeline planning', icon: Calendar },
      { name: 'Scholarship opportunity matching', icon: Award },
    ],
    faqs: [
      {
        q: "What's the difference between this and Profile Assessment?",
        a: 'Profile Assessment evaluates your eligibility. Pre-application prepares your actual documents (SOP, LOR, CV) for submission.',
      },
      {
        q: 'Will you write my SOP for me?',
        a: 'We provide detailed guidance, structure, and review — but the core content should reflect your genuine experience.',
      },
      {
        q: 'How many revisions are included?',
        a: 'Up to 3 revision rounds for SOP and CV.',
      },
      {
        q: 'Can I use these documents for multiple universities?',
        a: 'Yes, we help you create a master version that can be customized per university.',
      },
    ],
    prerequisites: [
      'Completed Profile Assessment (recommended)',
      'Academic transcripts',
      'Draft SOP (if available)',
      'Updated CV/Resume',
      'List of target universities',
    ],
    testimonials: [
      {
        name: 'Priya M.',
        country: 'India',
        university: 'UCL London',
        quote:
          'My SOP went from average to outstanding. The counselor was incredibly thorough.',
        rating: 5,
      },
      {
        name: 'Tariq H.',
        country: 'Pakistan',
        university: 'TU Munich',
        quote:
          'Great guidance on document preparation. Saved me weeks of confusion.',
        rating: 4,
      },
    ],
    stats: {
      studentsServed: '950+',
      satisfaction: '97%',
      avgCompletion: '10 days',
    },
    relatedServices: ['apply-university', 'visa-interview'],
  },

  'apply-university': {
    slug: 'apply-university',
    type: 'APPLICATION_ASSISTANCE',
    name: 'Apply to University',
    tagline:
      'End-to-end university application assistance — from form filling to offer letter analysis.',
    description:
      'End-to-end university application assistance including SOP, LOR, and submission.',
    duration: '2-4 weeks',
    price: '$199',
    icon: GraduationCap,
    heroIcon: applyUniversityIcon,
    heroImage: applyUniversityImg,
    popular: true,
    processSteps: [
      { label: 'You Apply', subtitle: 'Instant', icon: ClipboardList },
      { label: 'Admin Reviews', subtitle: '1-2 days', icon: Eye },
      { label: 'Counselor Assigned', subtitle: '1 day', icon: Users },
      {
        label: 'Applications Submitted to Universities',
        subtitle: '2-4 weeks',
        icon: FileCheck,
      },
      { label: 'Completed', subtitle: 'Offers received', icon: CheckCircle },
    ],
    deliverables: [
      { name: 'Apply to up to 5 universities', icon: Building2 },
      { name: 'Application form filling assistance', icon: ClipboardList },
      { name: 'Document submission management', icon: Upload },
      { name: 'Application fee guidance', icon: CreditCard },
      { name: 'Admission tracking & follow-ups', icon: Activity },
      { name: 'Offer letter analysis & comparison', icon: Scale },
    ],
    faqs: [
      {
        q: 'How many universities can I apply to?',
        a: 'The base package includes up to 5 universities. Additional applications available at discounted rates.',
      },
      {
        q: 'Do you guarantee admission?',
        a: 'We cannot guarantee admission, but we maximize your chances with strategic university selection and strong applications.',
      },
      {
        q: 'What countries do you cover?',
        a: 'We support applications to 52+ countries and 4000+ universities worldwide.',
      },
      {
        q: 'Who fills the application forms?',
        a: 'Our counselors assist you step-by-step. You provide the information, we handle the technical submission.',
      },
    ],
    prerequisites: [
      'Completed Profile Assessment',
      'Statement of Purpose (draft)',
      'Letters of Recommendation (2-3)',
      'Academic transcripts (official)',
      'English proficiency test score',
      'Passport copy',
    ],
    testimonials: [
      {
        name: 'Rahul S.',
        country: 'India',
        university: 'University of Waterloo',
        quote:
          'Applied to 5 universities and got into 4! The team handled everything seamlessly.',
        rating: 5,
      },
      {
        name: 'Fatima A.',
        country: 'UAE',
        university: "King's College London",
        quote:
          'The application process was stress-free. They tracked every deadline perfectly.',
        rating: 5,
      },
    ],
    stats: {
      studentsServed: '2,100+',
      satisfaction: '96%',
      avgCompletion: '3 weeks',
    },
    relatedServices: ['visa-interview', 'accommodation'],
  },

  'visa-interview': {
    slug: 'visa-interview',
    type: 'VISA_GUIDANCE',
    name: 'Visa & Interview Support',
    tagline:
      'Complete visa application guidance and mock interview preparation to maximize your approval chances.',
    description:
      'Complete visa application guidance and mock interview preparation.',
    duration: '1-3 weeks',
    price: '$179',
    icon: Plane,
    heroIcon: visaInterviewIcon,
    heroImage: visaInterviewImg,
    popular: false,
    processSteps: [
      { label: 'You Apply', subtitle: 'Instant', icon: ClipboardList },
      { label: 'Admin Reviews', subtitle: '1-2 days', icon: Eye },
      { label: 'Counselor Assigned', subtitle: '1 day', icon: Users },
      {
        label: 'Interview Prep & Visa Filing',
        subtitle: '1-3 weeks',
        icon: FileCheck,
      },
      { label: 'Completed', subtitle: 'Visa secured', icon: CheckCircle },
    ],
    deliverables: [
      { name: 'Visa application form assistance', icon: FileCheck },
      { name: 'Embassy appointment booking guidance', icon: Calendar },
      { name: 'Mock interview sessions (2 rounds)', icon: Video },
      { name: 'Interview question preparation', icon: MessageCircle },
      { name: 'Financial document preparation', icon: Wallet },
      { name: 'Visa tracking & status updates', icon: Eye },
    ],
    faqs: [
      {
        q: 'How many mock interview sessions are included?',
        a: '2 full mock interview rounds with detailed feedback and improvement tips.',
      },
      {
        q: 'Do you handle embassy appointment booking?',
        a: 'We guide you through the booking process and help you prepare all required documents.',
      },
      {
        q: 'What if my visa gets rejected?',
        a: 'We analyze the rejection reason and help you re-apply with a stronger application. Re-application support is discounted.',
      },
      {
        q: "Which countries' visas do you support?",
        a: 'We support visa applications for all major study destinations including USA, UK, Canada, Australia, Germany, and more.',
      },
    ],
    prerequisites: [
      'University admission/offer letter',
      'Valid passport (6+ months validity)',
      'Financial proof documents',
      'Academic transcripts',
      'English proficiency test score',
      'Passport-size photographs',
    ],
    testimonials: [
      {
        name: 'Nadia L.',
        country: 'Nepal',
        university: 'University of British Columbia',
        quote:
          'The mock interviews gave me so much confidence. Got my visa approved on the first try!',
        rating: 5,
      },
      {
        name: 'Daniel O.',
        country: 'Nigeria',
        university: 'University of Manchester',
        quote:
          'Excellent visa guidance. They knew exactly what the embassy looks for.',
        rating: 5,
      },
    ],
    stats: {
      studentsServed: '1,800+',
      satisfaction: '99%',
      avgCompletion: '2 weeks',
    },
    relatedServices: ['ticket-travel', 'accommodation'],
  },

  'ticket-travel': {
    slug: 'ticket-travel',
    type: 'SCHOLARSHIP_SEARCH',
    name: 'Ticket & Travel Support',
    tagline:
      'Flight booking, airport pickup, travel insurance, and everything you need for a smooth departure.',
    description:
      'Find scholarships you qualify for and get assistance with travel arrangements.',
    duration: '1-2 weeks',
    price: '$129',
    icon: Globe,
    heroIcon: ticketTravelIcon,
    heroImage: ticketTravelImg,
    popular: false,
    processSteps: [
      { label: 'You Apply', subtitle: 'Instant', icon: ClipboardList },
      { label: 'Admin Reviews', subtitle: '1-2 days', icon: Eye },
      { label: 'Counselor Assigned', subtitle: '1 day', icon: Users },
      {
        label: 'Tickets Booked & Itinerary Confirmed',
        subtitle: '1-2 weeks',
        icon: FileCheck,
      },
      { label: 'Completed', subtitle: 'Ready to fly', icon: CheckCircle },
    ],
    deliverables: [
      { name: 'Flight ticket booking assistance', icon: Plane },
      { name: 'Airport pickup coordination', icon: MapPin },
      { name: 'Travel insurance guidance', icon: Shield },
      { name: 'Pre-departure orientation checklist', icon: CheckCircle },
      { name: 'Emergency travel contact setup', icon: Phone },
      { name: 'Currency & banking tips', icon: Banknote },
    ],
    faqs: [
      {
        q: 'Do you book the tickets for me?',
        a: 'We assist with finding the best deals and guide you through booking. Final payment is made by you directly.',
      },
      {
        q: 'Is travel insurance mandatory?',
        a: "It depends on your destination country. We'll advise what's required and help you find the best plan.",
      },
      {
        q: 'Can you arrange airport pickup?',
        a: 'Yes, we coordinate with local partners at your destination for airport pickup services.',
      },
      {
        q: 'What if my travel plans change?',
        a: 'We help with rebooking and schedule adjustments at no extra charge.',
      },
    ],
    prerequisites: [
      'Valid passport with visa',
      'University enrollment confirmation',
      'Travel dates (tentative)',
      'Budget range for flights',
    ],
    testimonials: [
      {
        name: 'Sarah J.',
        country: 'Sri Lanka',
        university: 'Monash University',
        quote:
          'They found me a great flight deal and arranged pickup. Felt so safe arriving in a new country!',
        rating: 5,
      },
      {
        name: 'Kevin T.',
        country: 'Ghana',
        university: 'Seneca College',
        quote:
          "The pre-departure checklist was a lifesaver. I didn't miss a thing.",
        rating: 4,
      },
    ],
    stats: {
      studentsServed: '800+',
      satisfaction: '97%',
      avgCompletion: '5 days',
    },
    relatedServices: ['accommodation', 'jobs-abroad'],
  },

  accommodation: {
    slug: 'accommodation',
    type: 'ACCOMMODATION_HELP',
    name: 'Find Accommodation',
    tagline:
      'University housing, private rentals, roommate matching — find your perfect home abroad.',
    description:
      'Housing search and setup assistance in your destination country.',
    duration: '1-2 weeks',
    price: '$149',
    icon: Home,
    heroIcon: accommodationIcon,
    heroImage: accommodationImg,
    popular: false,
    processSteps: [
      { label: 'You Apply', subtitle: 'Instant', icon: ClipboardList },
      { label: 'Admin Reviews', subtitle: '1-2 days', icon: Eye },
      { label: 'Counselor Assigned', subtitle: '1 day', icon: Users },
      {
        label: 'Housing Options Secured',
        subtitle: '1-2 weeks',
        icon: FileCheck,
      },
      { label: 'Completed', subtitle: 'Home secured', icon: CheckCircle },
    ],
    deliverables: [
      { name: 'University housing application support', icon: Home },
      { name: 'Private accommodation search', icon: Search },
      { name: 'Lease agreement review', icon: FileText },
      { name: 'Area safety & commute analysis', icon: MapPin },
      { name: 'Roommate matching assistance', icon: Users },
      { name: 'Move-in checklist & essentials guide', icon: Package },
    ],
    faqs: [
      {
        q: 'Do you only help with university housing?',
        a: 'No, we help with both university-managed and private housing options.',
      },
      {
        q: 'Can you help find roommates?',
        a: 'Yes! We connect students heading to the same city and help coordinate shared accommodation.',
      },
      {
        q: 'Do you review lease agreements?',
        a: 'Absolutely. We review lease terms to ensure there are no unfavorable clauses.',
      },
      {
        q: 'How early should I start looking?',
        a: 'Ideally 2-3 months before your program starts. Earlier is better for popular cities.',
      },
    ],
    prerequisites: [
      'University admission confirmation',
      'Program start date',
      'Monthly budget range',
      'Housing preferences (shared/private)',
      'Destination city',
    ],
    testimonials: [
      {
        name: 'Li Wei C.',
        country: 'China',
        university: 'University of Sydney',
        quote:
          'Found amazing accommodation close to campus. The lease review saved me from a bad contract!',
        rating: 5,
      },
      {
        name: 'Maria G.',
        country: 'Brazil',
        university: 'TU Berlin',
        quote:
          'Roommate matching was great. Living with someone from the same program made the transition easier.',
        rating: 4,
      },
    ],
    stats: {
      studentsServed: '650+',
      satisfaction: '95%',
      avgCompletion: '8 days',
    },
    relatedServices: ['jobs-abroad', 'education-loan'],
  },

  'education-loan': {
    slug: 'education-loan',
    type: 'LOAN_ASSISTANCE',
    name: 'Education Loan',
    tagline:
      'Loan eligibility assessment, bank comparisons, and end-to-end application support.',
    description: 'Financial assistance and loan processing with partner banks.',
    duration: '2-4 weeks',
    price: '$99',
    icon: DollarSign,
    heroIcon: educationLoanIcon,
    heroImage: educationLoanImg,
    popular: false,
    processSteps: [
      { label: 'You Apply', subtitle: 'Instant', icon: ClipboardList },
      { label: 'Admin Reviews', subtitle: '1-2 days', icon: Eye },
      { label: 'Counselor Assigned', subtitle: '1 day', icon: Users },
      {
        label: 'Loan Application Processed',
        subtitle: '2-4 weeks',
        icon: FileCheck,
      },
      { label: 'Completed', subtitle: 'Loan approved', icon: CheckCircle },
    ],
    deliverables: [
      { name: 'Loan eligibility assessment', icon: Calculator },
      { name: 'Bank & NBFC comparison report', icon: Scale },
      { name: 'Application documentation support', icon: FileText },
      { name: 'Interest rate & EMI breakdown', icon: TrendingDown },
      { name: 'Collateral guidance', icon: Lock },
      { name: 'Disbursement tracking', icon: Activity },
    ],
    faqs: [
      {
        q: 'Do I need collateral for an education loan?',
        a: 'It depends on the loan amount and lender. We help you find both collateral and non-collateral options.',
      },
      {
        q: "What's the typical interest rate?",
        a: 'Rates vary by lender and country. We compare options to find you the best rate, typically 8-12% for Indian banks.',
      },
      {
        q: 'How long does loan approval take?',
        a: 'Usually 2-4 weeks after document submission, depending on the bank.',
      },
      {
        q: 'Can I get a loan for living expenses too?',
        a: 'Yes, many lenders cover tuition + living expenses. We help you understand what each bank covers.',
      },
    ],
    prerequisites: [
      'University admission/offer letter',
      'Co-applicant details (parent/guardian)',
      'Income proof (co-applicant)',
      'Academic transcripts',
      'Cost estimate from university',
      'Collateral documents (if applicable)',
    ],
    testimonials: [
      {
        name: 'Arjun P.',
        country: 'India',
        university: 'Arizona State University',
        quote:
          'Got my loan approved in just 3 weeks. The comparison report helped me choose the best bank.',
        rating: 5,
      },
      {
        name: 'Pooja R.',
        country: 'India',
        university: 'University of Exeter',
        quote:
          "They found me a no-collateral loan option I didn't even know existed!",
        rating: 5,
      },
    ],
    stats: {
      studentsServed: '500+',
      satisfaction: '96%',
      avgCompletion: '3 weeks',
    },
    relatedServices: ['apply-university', 'visa-interview'],
  },

  'jobs-abroad': {
    slug: 'jobs-abroad',
    type: 'PRE_DEPARTURE_ORIENTATION',
    name: 'Find Jobs Abroad',
    tagline:
      'International resume prep, job market analysis, LinkedIn optimization, and work permit guidance.',
    description:
      'Comprehensive preparation for your journey abroad including culture and logistics.',
    duration: '3-5 days',
    price: '$199',
    icon: Briefcase,
    heroIcon: jobsAbroadIcon,
    heroImage: jobsAbroadImg,
    popular: false,
    processSteps: [
      { label: 'You Apply', subtitle: 'Instant', icon: ClipboardList },
      { label: 'Admin Reviews', subtitle: '1-2 days', icon: Eye },
      { label: 'Counselor Assigned', subtitle: '1 day', icon: Users },
      {
        label: 'Job Matching & Applications',
        subtitle: '3-5 days',
        icon: FileCheck,
      },
      { label: 'Completed', subtitle: 'Applications sent', icon: CheckCircle },
    ],
    deliverables: [
      { name: 'International resume/CV preparation', icon: FileEdit },
      { name: 'Job market analysis for your field', icon: BarChart3 },
      { name: 'LinkedIn profile optimization', icon: Linkedin },
      { name: 'Job portal registration assistance', icon: Globe },
      { name: 'Interview preparation (international)', icon: Video },
      { name: 'Work permit & visa guidance', icon: Briefcase },
    ],
    faqs: [
      {
        q: 'Can I work while studying?',
        a: 'Most countries allow part-time work on student visas (typically 20 hrs/week). We guide you on the rules for your destination.',
      },
      {
        q: 'Do you guarantee job placement?',
        a: 'We cannot guarantee placement, but we optimize your profile, prepare you for interviews, and connect you with opportunities.',
      },
      {
        q: 'Which job portals do you register me on?',
        a: 'We help with LinkedIn, Indeed, Glassdoor, and country-specific portals relevant to your field.',
      },
      {
        q: 'Is this for post-graduation jobs or part-time?',
        a: "Both! We tailor our approach based on whether you're looking for part-time work during studies or full-time post-graduation.",
      },
    ],
    prerequisites: [
      'Updated CV/Resume',
      'LinkedIn profile (existing or new)',
      'Target job field/industry',
      'Destination country confirmed',
      'Work permit status (if applicable)',
    ],
    testimonials: [
      {
        name: 'James K.',
        country: 'Kenya',
        university: 'University of Ottawa',
        quote:
          'Landed a part-time job within 2 weeks of arriving. The LinkedIn optimization made a huge difference!',
        rating: 5,
      },
      {
        name: 'Mina S.',
        country: 'Egypt',
        university: 'University of Amsterdam',
        quote:
          'Great job market insights for my field. The international CV format was very different from what I had.',
        rating: 4,
      },
    ],
    stats: {
      studentsServed: '400+',
      satisfaction: '94%',
      avgCompletion: '4 days',
    },
    relatedServices: ['ticket-travel', 'education-loan'],
  },
};

// ─── Status config for tracking ──────────────────────────────────
export const STATUS_CONFIG = {
  PENDING_ADMIN_ASSIGNMENT: {
    label: 'Pending Assignment',
    color: 'bg-slate-100 text-slate-700',
    icon: 'Clock',
    progress: 10,
  },
  ASSIGNED: {
    label: 'Assigned',
    color: 'bg-blue-100 text-blue-700',
    icon: 'User',
    progress: 30,
  },
  IN_PROGRESS: {
    label: 'In Progress',
    color: 'bg-amber-100 text-amber-700',
    icon: 'RefreshCw',
    progress: 60,
  },
  ON_HOLD: {
    label: 'On Hold',
    color: 'bg-orange-100 text-orange-700',
    icon: 'AlertCircle',
    progress: 50,
  },
  COMPLETED: {
    label: 'Completed',
    color: 'bg-emerald-100 text-emerald-700',
    icon: 'CheckCircle',
    progress: 100,
  },
  CANCELLED: {
    label: 'Cancelled',
    color: 'bg-red-100 text-red-700',
    icon: 'AlertCircle',
    progress: 0,
  },
};

// Helper: get service data by slug
export function getServiceBySlug(slug) {
  return SERVICE_DATA[slug] || null;
}

// Helper: get service data by type
export function getServiceByType(type) {
  return Object.values(SERVICE_DATA).find(s => s.type === type) || null;
}

// Helper: get theme by slug
export function getThemeBySlug(slug) {
  return SERVICE_THEMES[slug] || SERVICE_THEMES['profile-assessment'];
}

// Helper: slug from service type
export function getSlugFromType(type) {
  const entry = Object.entries(SERVICE_DATA).find(([, v]) => v.type === type);
  return entry ? entry[0] : null;
}
